<ng-container *transloco="let t; prefix: 'header'">
    <div class="container-xl skipper">
        <div class="visually-hidden-focusable overflow-hidden">
            <a (click)="$event.preventDefault();scrollToMainContent()"
                class=" m-1 p-2 d-inline-flex" tabindex="1">
                {{ t('skiptomaincontent')}}
            </a>
        </div>
    </div>
</ng-container>